import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVisaCategory, IVisaCategoryState } from "./visaCategoryModel";
import {
  createVisaCategory,
  deleteVisaCategory,
  getAllActiveVisaCategories,
  getAllVisaCategories,
  getVisaCategoryByID,
  updateVisaCategory,
  visaCategoryActiveInactive,
} from "./services/visa.services";

const initialState: IVisaCategoryState = {
  loading: false,
  formLoading: false,
  error: "",
  VisaCategoryList: [],
  VisaCategoryID: null,
  VisaCategoryDetail: {
    VisaCategory: "",
    IsActive: 1,
    VisaCountryID: null,
    ProcessingTime: "",
    VisaCost: 0,
  },
};

const visacategorySlice = createSlice({
  name: "visacategory",
  initialState,
  reducers: {
    clearVisaCategoryDetails: (state) => {
      state.VisaCategoryDetail = initialState.VisaCategoryDetail;
    },
    setVisaCategoryID: (state, action) => {
      state.VisaCategoryID = action.payload;
    },
    clearVisaCategoryID: (state) => {
      state.VisaCategoryID = initialState.VisaCategoryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllVisaCategories.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVisaCategories.fulfilled,
      (state, action: PayloadAction<IVisaCategory[]>) => {
        state.loading = false;
        state.VisaCategoryList = action.payload || [];
      }
    );
    builder.addCase(getAllVisaCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VisaCategoryList = [];
    });
    builder.addCase(getAllActiveVisaCategories.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveVisaCategories.fulfilled,
      (state, action: PayloadAction<IVisaCategory[]>) => {
        state.loading = false;
        state.VisaCategoryList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveVisaCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VisaCategoryList = [];
    });
    builder.addCase(createVisaCategory.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createVisaCategory.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createVisaCategory.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateVisaCategory.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateVisaCategory.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateVisaCategory.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteVisaCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVisaCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVisaCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(visaCategoryActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(visaCategoryActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(visaCategoryActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getVisaCategoryByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getVisaCategoryByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.VisaCategoryDetail = action.payload;
    });
    builder.addCase(getVisaCategoryByID.rejected, (state, action) => {
      state.formLoading = false;
      state.VisaCategoryDetail = initialState.VisaCategoryDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // builder.addCase(getVisaCategoryWiseDocumentData.pending, (state) => {
    //   state.loading = true;
    //   state.error = "";
    // });
    // builder.addCase(
    //   getVisaCategoryWiseDocumentData.fulfilled,
    //   (state, action: PayloadAction<IDocument[]>) => {
    //     state.loading = false;
    //     state.VisaDocumentList = action.payload || [];
    //   }
    // );
    // builder.addCase(
    //   getVisaCategoryWiseDocumentData.rejected,
    //   (state, action) => {
    //     state.loading = false;
    //     state.error = action.error.message || "Something went wrong";
    //     state.VisaDocumentList = [];
    //   }
    // );
  },
});

export const {
  clearVisaCategoryDetails,
  setVisaCategoryID,
  clearVisaCategoryID,
} = visacategorySlice.actions;
export default visacategorySlice.reducer;
